export default __webpack_public_path__ + "static/FS2S-InHub-134-f72b17e373ccd9f4d0199578b73caea5.jpg";